import easingProgress from 'easing-progress';
import { Component } from '../../base/Component';
import scoped from '../../utils/math/scoped';
import clamp from '../../utils/math/clamp';
/**
 * StaticTimeline is the base class for Timeline itself.
 * The difference between the coponents is that StaticTimeline has no animation:
 * no play & pause methods.
 */
export class StaticTimeline extends Component {
    constructor(initialProp, init = true) {
        super(initialProp, false);
        // set default vars
        this._progress = 0;
        this._easing = 0;
        this._nestedTimelines = [];
        if (init) {
            this.init();
        }
    }
    /**
     * Get default properties
     */
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { easing: this._app.prop.easing, scope: [0, 1], useNestedEasingProgress: false });
    }
    /**
     * Absolute progress of the timeline
     */
    get progress() {
        return this._progress;
    }
    set progress(val) {
        this._progress = val;
        this._handleProgress();
    }
    /**
     * Easing progress of the timeline
     */
    get easing() {
        return this._easing;
    }
    /**
     * Add a nested timeline
     */
    addNestedTimeline(tm) {
        // add the timeline to the stack
        this._nestedTimelines.push(tm);
    }
    /**
     * Handle progress event
     */
    _handleProgress() {
        // calculate easing progress
        this._easing = easingProgress(this._progress, this.prop.easing);
        // launch progress events
        this._callbacks.tbt('progress', {
            progress: this._progress,
            easing: this._easing,
        });
        // render
        this._renderNestedTimelines();
    }
    /**
     * Render nested timelines
     */
    _renderNestedTimelines() {
        const { length } = this._nestedTimelines;
        if (length === 0) {
            return;
        }
        // vars
        const progressForNested = this.prop.useNestedEasingProgress ? this.easing : this.progress;
        // render nested timelines
        for (let index = 0, l = length; index < l; index += 1) {
            const tm = this._nestedTimelines[index];
            // calculate progress of this very timeline
            const tmProgress = clamp(scoped(progressForNested, tm.prop.nestedScope), [0, 1]);
            tm.progress = tmProgress;
        }
    }
    /**
     * Destroy the animation frame
     */
    _destroy() {
        super._destroy();
        // destroy nested timelines
        this._nestedTimelines.forEach((tm) => {
            tm.destroy();
        });
    }
}
